import React from "react";
import { formatPrice } from "../../../shared/teamCurrencyFormatting";
import { useClassRegistrationCheckoutContext } from "../ClassRegistrationCheckoutContext";

function Row({ label, value, tone = null }) {
  return (
    <div className={`pc-summary-row${tone ? ` pc-summary-row--${tone}` : ""}`}>
      <span>{label}</span>
      <span>{value}</span>
    </div>
  );
}

export default function OrderSummary() {
  const { checkout, currencyCode } = useClassRegistrationCheckoutContext();
  const quote = checkout.summary;
  if (!quote) return null;

  const money = (amount) => formatPrice(amount, currencyCode);

  return (
    <div className="pc-summary" data-testid="order-summary">
      <Row label={`${quote.quantity} × ${money(quote.unit_price)}`} value={money(quote.subtotal)} />
      {Number(quote.discount) > 0 && <Row tone="success" label={quote.discount_label} value={`-${money(quote.discount)}`} />}
      {Number(quote.fees) > 0 && <Row label="Fees" value={money(quote.fees)} />}
      {Number(quote.taxes) > 0 && <Row label="Taxes" value={money(quote.taxes)} />}
      <div className="pc-summary-row pc-summary-row--total">
        <span>Total due</span>
        <span>{money(quote.total)}</span>
      </div>
    </div>
  );
}
